import { Progress } from "@/components/ui/progress"
import { X as XIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"
import CardsIndex from "./cards-index"
import { Button } from "@/components/ui/button"

interface GameHeaderProps {
  currentQuestionNumber: number
  numberOfQuestions: number
  isDisabled: boolean
  currentCardIndexInTheDeck: number
  totalCardsAmount: number
  name: string
}

const GameHeader = ({
  currentQuestionNumber,
  numberOfQuestions,
  isDisabled,
  currentCardIndexInTheDeck,
  totalCardsAmount,
  name,
}: GameHeaderProps) => {
  const navigate = useNavigate()

  const handleOnClose = () => {
    navigate("/flashcards", { replace: true })
  }

  return (
    <div className="flex w-full flex-col gap-4 p-5">
      <div className="flex w-full shrink-0 select-none items-center justify-between lg:justify-end">
        <div className="lg:hidden">
          <CardsIndex
            currentCardIndexInTheDeck={currentCardIndexInTheDeck}
            totalCardsAmount={totalCardsAmount}
          />
        </div>

        <Button
          className="shrink-0 bg-transparent p-0 text-gray-500"
          onClick={handleOnClose}
          disabled={isDisabled}
        >
          <XIcon className="!size-5" />
        </Button>
      </div>

      <div className="w-full shrink-0">
        <Progress
          value={(currentQuestionNumber / numberOfQuestions) * 100}
          className="h-3 bg-neutral-200 text-orange-500"
        />
      </div>

      <div className="flex w-full shrink-0 items-center justify-between">
        <p className="text-base font-bold text-gray-500">Mazo: {name}</p>
        <div className="hidden items-center justify-center gap-2 lg:flex">
          <p className="text-base font-bold text-gray-500">Carta:</p>
          <CardsIndex
            currentCardIndexInTheDeck={currentCardIndexInTheDeck}
            totalCardsAmount={totalCardsAmount}
          />
        </div>
      </div>
    </div>
  )
}

export default GameHeader
